
<template>
  <div>
    <v-form ref="formProduct" v-model="is_valid" lazy-validation>
      <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0">
        <v-stepper-step :complete="stepper > 1" step="1" :editable="stepper > 1">
          Identificação
        </v-stepper-step>
        <v-stepper-content :complete="stepper > 1" step="1">
          <v-col cols="12">
            <v-card color="white lighten-1" class="mb-2 pa-3" height="" >
              <v-select
                v-if="!hideBrandSelect"
                :rules="[rules.required]"
                :items="brands"
                v-model="product.brand_id"
                item-text="name" item-value="id"
                label="Marca"
                prepend-icon="mdi-information"
                :menu-props="{ top: false, offsetY: true }"
              ></v-select>
              
              <v-select
                :rules="[rules.required]"
                :items="all_segments"
                v-model="product.segment_id"
                item-text="name" item-value="id"
                label="Segmento"
                prepend-icon="mdi-information"
                :menu-props="{ top: false, offsetY: true }"
              ></v-select>
              <v-text-field v-model="product.name" label="Nome do Produto" prepend-icon="mdi-information" :rules="[rules.required]">
                <template v-slot:prepend-inner>
                </template>
              </v-text-field> <!-- @change="verifyProduct(product.name)" -->

              <v-col>
                <span class="font-weight-bold">Nome final do Produto:</span>
                <span class="font-weight-bold">
                  {{ brandName }} {{ segmentName }} {{ product?.name?.toUpperCase() || '' }}
                </span>
              </v-col>

            </v-card>
            <f-btn save @click="submitProduct()" :disabled="!is_valid"></f-btn>
          </v-col>
        </v-stepper-content>
      </v-stepper>
    </v-form>
    <dialog-loading v-if="saving" loadingText="Salvando"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'RegisterProduct',
  props:{
    all_products:{
      type: Array,
      default(){return []},
    },
    brands:{
      type: Array,
      default(){return []},
    },
    defaultBrandId: {
      type: Number,
      default: null,
    },
    hideBrandSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      is_valid: true,
      product:{
        name: '',
        segment_id: null,
        brand_id: null
      },
      saving: false,
      all_segments: [],
      stepper: 1,
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
    }
  },
  methods: {
    getSegments(){
      if(this.product.brand_id) {
        Api.Supplier.indexSegment({brand_id: this.product.brand_id}).then(r=>r.data).then(d=> {
          this.all_segments = [...d]
        })
      }
    },
    submitProduct(){
      if (this.$refs.formProduct.validate()){
        this.swallConfirmation({
          title: `Deseja cadastrar produto?`,
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            const {name, ...rest} = this.product
            const product = {
              ...rest,
              name: `${this.brandName} ${this.segmentName} ${name.toUpperCase()}`,
            }
            this.saving = true
            Api.Supplier.createProduct(product).then((r) => {
              this.$refs.formProduct.reset()
              if (this.defaultBrandId) {
                this.product.brand_id = this.defaultBrandId
              }
              this.$emit('created', r.data)
              this.addNotification({type: 'success',  msg: 'Cadastrado com sucesso.'})
            }).catch((err) => {
              if(err.response?.data?.errors.length > 0){
                this.addNotification({type: 'error',  msg: err.response?.data?.errors?.toString()})
              }else{ 
                this.addNotification({type: 'error',  msg: `Não foi possível concluir a solicitação.`})
              }
            }).finally(() => {
              this.saving = false
            })
          }
        })
      }
    },
    ...mapActions({
      
      pushNewSupplier: 'Supplier/pushNewSupplier',
    })
  },
  computed: {
    brandName(){
      return this.brands.find(b => b.id === this.product.brand_id)?.name.toUpperCase() || ''
    },
    segmentName(){
      return this.all_segments.find(s => s.id === this.product.segment_id)?.name.toUpperCase() || ''
    }
  },
  mounted () {
    if (this.defaultBrandId) {
      this.product.brand_id = this.defaultBrandId
    }
    this.getSegments();
  },
  watch: {
    'product.brand_id'(nv, ov) {
      if(nv) {
        this.product.segment_id = null
        this.getSegments();
      }
    }
  }
}
</script>
